import { makeStyles } from '@material-ui/core';

// The mark on its own, shown when the sidebar is collapsed.
const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src="/logo.svg" alt="" />;
};
